const RELOAD_FLAG_KEY = "chunk-error-reload-attempted";

const CHUNK_ERROR_PATTERN =
  /Loading chunk [\w.-]+ failed|ChunkLoadError|Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i;

function extractMessage(reason: unknown): string {
  if (reason instanceof Error) return reason.message;
  if (typeof reason === "string") return reason;
  if (reason && typeof reason === "object" && "message" in reason) {
    return String((reason as { message: unknown }).message ?? "");
  }

  return "";
}

function isChunkLoadError(message: string): boolean {
  return CHUNK_ERROR_PATTERN.test(message);
}

function reloadOnce(): void {
  if (sessionStorage.getItem(RELOAD_FLAG_KEY)) return;
  sessionStorage.setItem(RELOAD_FLAG_KEY, "1");
  window.location.reload();
}

export function installChunkErrorReloader(): void {
  window.addEventListener("error", (event) => {
    if (isChunkLoadError(event.message ?? "")) reloadOnce();
  });

  window.addEventListener("unhandledrejection", (event) => {
    if (isChunkLoadError(extractMessage(event.reason))) reloadOnce();
  });
}

export function clearChunkErrorReloadFlag(): void {
  sessionStorage.removeItem(RELOAD_FLAG_KEY);
}
